import styled from '@emotion/styled';
import { logo, mediaQueries, remCalc, palette } from '../../css';

const StyledSvg = styled('svg')(({ aColor, size, theme, vertical }) => {
    let style = {
        // @TODO: remove - security before moving all components with a logo to emotion
        fill: theme.logo ? theme.logo[aColor] : palette('secondary', 'arteOrange'),
    };
    if (typeof size === 'string') {
        style = vertical
            ? {
                  ...style,
                  ...logo.size[size],
                  border: 0,
              }
            : {
                  ...style,
                  height: logo.size[size].width,
                  width: logo.size[size].height,
                  [mediaQueries.mediumLarge]: {
                      paddingRight: remCalc(10),
                  },
              };
    } else {
        Object.keys(size).forEach(bp => {
            const values = logo.size[size[bp]];
            if (bp === 'default') {
                style = { ...style, ...values };
            } else {
                style[mediaQueries[bp]] = values;
            }
        });
    }
    return style;
});

export { StyledSvg };
